export default {"src":"/_next/static/media/logo-blaze.f5612c51.svg","height":75,"width":200,"blurWidth":0,"blurHeight":0};